export const BREAKPOINT_BIG = 1450;
export const BREAKPOINT_HD = 1366;
export const BREAKPOINT_XL = 1200;
export const BREAKPOINT_LG = 1024;
export const BREAKPOINT_MD = 767;
export const BREAKPOINT_MLT_MD = 670;
export const BREAKPOINT_SM = 576;